import { useEffect, useState } from "react";
import APIS from "../../api/api";
import React from "react";
import View from "../../view/creators/creators";
import CreationBannerData from "../../model/creators/creationBannerData";
import RecommendMaterialGroup from "../../model/creators/recommendMaterialData";

const Presenter: React.FC = () => {
    const [creationList, SetCreationBannerData] = useState<CreationBannerData[]>([]);
    const [materialGroupList, SetRecommendMaterial] = useState<RecommendMaterialGroup[]>([]);
    const [isSuccess, SetIsSuccess] = useState(false);

    const creatorPage = () => {
        APIS.creatorPage({}).then((res => {
            console.log("API Success!!!!!!!!!!!");

            SetCreationBannerData(res.creationList);
            SetRecommendMaterial(res.materialGroupList);
            SetIsSuccess(true);

            // レスポンスセット
        })).catch((err) => {
            console.log("API Error : " + err);
        });
    }

    useEffect(() => {
        creatorPage();
    },[]);

    return <View creationList={creationList} materialGroup={materialGroupList} isSuccess={isSuccess}/>;
};

export default Presenter;